<template>
  <div class="footer-box">
    <!-- Nav -->
    <Nav />

    <!-- content -->
    <div class="info-box">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/footer/icon1.png" alt="" />
          <div class="text-box">
            <div class="title">河北总部</div>
            <div class="text">衡水市桃城区城市杰座A 座 11 层</div>
          </div>
        </div>

        <div class="item">
          <img class="icon" src="@/assets/footer/icon1.png" alt="" />
          <div class="text-box">
            <div class="title">北京分公司</div>
            <div class="text">北京市房山区长阳镇溪雅苑一区12号1层</div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="item">
          <img
            src="@/assets/footer/icon2.png"
            class="icon"
            style="margin-right: 0.375rem"
          />
          <div class="text-box">
            <div class="title">联系电话</div>
            <div class="text">
              闫丽琴 18231817521
              <span style="margin-left: 1.5rem">冷建斐 18330855518</span>
              <span style="margin-left: 2.9375rem"
                >shanmuzhi@shanmuzhi.com</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title-box">
          <div class="icon"><img src="@/assets/footer/icon4.png" alt="" /></div>
          <div class="title">关注我们</div>
        </div>
        <div class="text">扫码关注公众号</div>
        <div class="qrcode">
          <img src="@/assets/qrcode.png" alt="" />
        </div>
      </div>
    </div>

    <!-- record -->
    <div class="record-box">
      <div class="left">CopyRight @ 2017-2025 shanmuzhi.com Design</div>
      <div class="right" style="cursor: pointer" @click="toICP">
        All Rights Reserved 备案号：{{ ICPtext() }}
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './components/Nav';
export default {
  components: { Nav },
  data() {
    return {
      routeList: [
        { title: 'Home 首页', name: 'home' },
        { title: 'Business 业务', name: 'business' },
        { title: 'Case 案例', name: 'case' },
        { title: 'About 关于', name: 'about' },
        { title: 'Team 团队', name: 'team' },
        { title: 'Contact 联系', name: 'contact' },
      ],
    };
  },
  computed: {
    active() {
      return this.$store.state.route.activeRoute;
    },
  },
  methods: {
    toHref(item) {
      this.$router.push({ name: item.name });
      this.$store.dispatch('updateActiveRoute', item.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./index.scss');
</style>
